import { useEffect } from 'react';
import { useDispatch, useSelector } from 'shared/hooks';
import analytics from 'shared/utility/analytics';
import { Heading, LabelText, Info } from 'shared/components';
import { CurrencyInput } from 'shared/inputs';
import { InputsContainer } from 'shared/containers';
import { sync } from 'shared/wizard/actions';

const WizardOriginal = () => {
  const dispatch = useDispatch();
  const syncAction = sync(dispatch);
  const {
    input: { original_mortgage_amount, original_house_value },
    output: { errors },
  } = useSelector(state => state);
  useEffect(() => {
    analytics.send('Navigeer', 'Oorspronkelijke situatie');
  }, []);

  return (
    <>
      <Heading>Oorspronkelijke situatie</Heading>
      <InputsContainer>
        <LabelText>
          Hoe hoog was je hypotheek bij de start van de huidige rentevaste periode?
          <Info title="Hoogte van je hypotheek bij de start">
            Het gaat hier om het hypotheekbedrag bij de start van de huidige rentevaste periode. Is de rente nog niet
            gewijzigd, vul dan in wat je bij de aanschaf van de woning aan hypotheek kreeg. Kwam je een nieuwe rente
            (periode) overeen, vul dan het bedrag in wat er op dat moment nog aan hypotheek open stond.
          </Info>
        </LabelText>
        <CurrencyInput
          onChange={syncAction('original_mortgage_amount')}
          value={original_mortgage_amount}
          errors={errors.original_mortgage_amount}
          placeholder="Bedrag"
        />
        <LabelText>
          Wat was je woning waard bij de start van de huidige rentevaste periode?
          <Info title="Woningwaarde bij de start">
            Het gaat hier om de taxatiewaarde van de woning bij de start van de huidige rentevaste periode. Is de rente
            nog niet gewijzigd, vul dan in wat je woning waard was toen je de hypotheek kreeg (heb je geen
            taxatiewaarde, vul dan de koopsom in). Kwam je een nieuwe rente (periode) overeen, vul dan in wat de woning
            op dat moment waard was.
          </Info>
        </LabelText>
        <CurrencyInput
          onChange={syncAction('original_house_value')}
          value={original_house_value}
          errors={errors.original_house_value}
          placeholder="Bedrag"
        />
      </InputsContainer>
    </>
  );
};

export default WizardOriginal;
